// 省 -> 市 区域数据（覆盖主要省份与核心城市，可按需扩展）
// 用于管理后台的区域筛选 cascader
//
// 注意：选择城市后是否绘制地图遮罩，由 src/views/dashboard/regional-map.vue 的
// CITY_CENTERS 决定。当前仅以下 5 个核心城市配置了遮罩边界（DistrictSearch）：
//   - 上海市、南京市、苏州市、无锡市、常州市
// 选其他城市时地图退化为普通全国/省视图，不画遮罩。

export const PROVINCE_CITY_MAP = {
  '北京市': ['北京市'],
  '上海市': ['上海市'],
  '天津市': ['天津市'],
  '重庆市': ['重庆市'],
  '江苏省': ['南京市', '苏州市', '无锡市', '常州市', '南通市', '徐州市', '扬州市', '盐城市', '镇江市', '泰州市', '宿迁市', '淮安市', '连云港市'],
  '浙江省': ['杭州市', '宁波市', '温州市', '绍兴市', '嘉兴市', '台州市', '金华市', '湖州市', '丽水市', '衢州市', '舟山市'],
  '广东省': ['广州市', '深圳市', '东莞市', '佛山市', '中山市', '珠海市', '惠州市', '江门市', '汕头市', '湛江市', '肇庆市', '茂名市'],
  '山东省': ['济南市', '青岛市', '烟台市', '潍坊市', '临沂市', '淄博市', '济宁市', '泰安市', '威海市', '德州市', '聊城市'],
  '河南省': ['郑州市', '洛阳市', '开封市', '南阳市', '新乡市', '安阳市', '商丘市', '许昌市', '平顶山市', '周口市'],
  '河北省': ['石家庄市', '唐山市', '保定市', '邯郸市', '廊坊市', '沧州市', '秦皇岛市', '邢台市', '张家口市'],
  '湖北省': ['武汉市', '宜昌市', '襄阳市', '黄石市', '十堰市', '荆州市', '荆门市', '孝感市', '黄冈市'],
  '湖南省': ['长沙市', '株洲市', '湘潭市', '衡阳市', '岳阳市', '常德市', '益阳市', '邵阳市'],
  '四川省': ['成都市', '绵阳市', '德阳市', '宜宾市', '泸州市', '南充市', '自贡市', '乐山市'],
  '福建省': ['福州市', '厦门市', '泉州市', '漳州市', '莆田市', '宁德市'],
  '安徽省': ['合肥市', '芜湖市', '蚌埠市', '马鞍山市', '安庆市', '阜阳市', '滁州市'],
  '辽宁省': ['沈阳市', '大连市', '鞍山市', '抚顺市', '锦州市', '营口市'],
  '陕西省': ['西安市', '咸阳市', '宝鸡市', '渭南市', '汉中市'],
  '江西省': ['南昌市', '赣州市', '九江市', '上饶市', '宜春市'],
  '广西壮族自治区': ['南宁市', '柳州市', '桂林市', '北海市', '玉林市'],
  '云南省': ['昆明市', '曲靖市', '玉溪市', '大理市'],
  '贵州省': ['贵阳市', '遵义市', '安顺市'],
  '山西省': ['太原市', '大同市', '临汾市', '运城市'],
  '黑龙江省': ['哈尔滨市', '齐齐哈尔市', '大庆市', '牡丹江市'],
  '吉林省': ['长春市', '吉林市', '四平市'],
  '内蒙古自治区': ['呼和浩特市', '包头市', '鄂尔多斯市', '赤峰市'],
  '甘肃省': ['兰州市', '天水市'],
  '海南省': ['海口市', '三亚市'],
  '宁夏回族自治区': ['银川市'],
  '青海省': ['西宁市'],
  '新疆维吾尔自治区': ['乌鲁木齐市', '克拉玛依市'],
  '西藏自治区': ['拉萨市']
}

// 转换为 el-cascader 所需的选项结构（支持任意层级选择）
export function getCascaderOptions() {
  return Object.keys(PROVINCE_CITY_MAP).map(province => ({
    value: province,
    label: province,
    children: PROVINCE_CITY_MAP[province].map(city => ({
      value: city,
      label: city
    }))
  }))
}
